import script from "./GreenifiedButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./GreenifiedButton.vue?vue&type=script&setup=true&lang=ts"

import "./GreenifiedButton.vue?vue&type=style&index=0&id=5eb66bfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb66bfe"]])

export default __exports__